import { Checkbox as FlowbiteCheckbox } from "flowbite-react";
import { useRef } from "react";
import "./checkbox.css";

/**
 * Checkbox Component
 * 
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes for the checkbox input
 * @param {string} props.containerClassName - Additional CSS classes for the container div
 * @param {Object} props.rest - Additional props passed to Flowbite Checkbox
 */
export default function Checkbox({ className = '', containerClassName = '', ...props }) {
    const checkboxRef = useRef(null);

    return (
        <div className={`flex items-center gap-2 ${containerClassName}`}>
            <FlowbiteCheckbox
                ref={checkboxRef}
                className={`checkbox-primary ${className}`}
                {...props}
            />
        </div>
    );
}
